import React from 'react';
import {classes} from './AsideSummary.st.css';
import {useControllerProps} from '../../Widget/ControllerContext';
import {SummaryLocation} from '../../../../types/checkoutApp.types';
import {TopMobileSummary} from '../TopMobileSummary/TopMobileSummary';
import {CartSummary} from '../CartSummary';
import {CheckoutSlot} from '../../CheckoutSlot';
import {SlotId} from '../../../../domain/utils/slotId';

export enum SummaryDataHooks {
  couponSectionInput = 'SummaryDataHooks.couponSectionInput',
  giftCardSectionInput = 'SummaryDataHooks.giftCardSectionInput',
  violations = 'SummaryDataHooks.violations',
}

export interface SummaryProps {
  location: SummaryLocation;
  dataHook: string;
  checkboxesRef?: React.RefObject<HTMLDivElement>;
}

export const AsideSummary = ({dataHook}: SummaryProps) => {
  const {
    checkoutStore: {isFastFlow},
    isOneColumnView,
  } = useControllerProps();
  const shouldShowSlot = !isFastFlow;
  return (
    <div className={classes.root} data-hook={dataHook}>
      {isOneColumnView ? (
        <TopMobileSummary />
      ) : (
        <>
          {shouldShowSlot && <CheckoutSlot className={classes.slotBefore} slotId={SlotId.BeforeSummaryCheckoutSlot} />}
          <CartSummary showSlots={shouldShowSlot} />
          {shouldShowSlot && <CheckoutSlot className={classes.slotAfter} slotId={SlotId.AfterSummaryCheckoutSlot} />}
        </>
      )}
    </div>
  );
};
